import React from 'react';

import { PrinterOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import classNames from 'classnames';
import { useDispatch } from 'dva';

import DownloadFileOutlined from '@/assets/icons/download_file_outlined.svg';
import EyeFilled from '@/assets/icons/eye_filled.svg';

import { CoreEnums } from '@/utils/domain/constants';
import styles from './style.less';

const FileRow = ({
  fileName,
  downloadUrl,
  documentTemporaryUrl,
  contentType,
  isRecent,
  isReadable,
  isBase64,
  ...props
}) => {
  const dispatch = useDispatch();

  const type = _.camelCase(
    CoreEnums.AttachmentFileTypeClassificationStatus[props.fileTypeClassification ?? 0],
  );

  const handleDownload = () => {
    dispatch({
      type: 'global/directDownload',
      payload: {
        fileName,
        downloadUrl: downloadUrl ?? documentTemporaryUrl,
      },
    });
  };

  const handlePreview = () => {
    dispatch({
      type: 'global/filePreview',
      payload: {
        isBase64,
        fileType: contentType,
        filePath: isBase64
          ? props.content
          : props.previewUrl ?? downloadUrl ?? documentTemporaryUrl,
        filename: fileName,
      },
    });
  };

  return (
    <Space className={styles.uploaded} size={8}>
      {isReadable && (
        <div className={classNames(styles.fileName, styles[type])}>
          <div className={classNames(styles.icon, styles[type])} />
        </div>
      )}
      <Space
        direction="vertical"
        className={styles.container}
        size={isReadable && props.creator ? 4 : 8}
      >
        <Space
          className={classNames(styles.wrapper, !isReadable && styles.isEditable)}
          direction={isReadable ? 'vertical' : 'horizontal'}
          size={isReadable ? 0 : 4}
        >
          <h4>{fileName}</h4>
          {isReadable && props.creator && <h4>{`(${props.creator})`}</h4>}
          {props.children}
        </Space>
        {!isRecent && (
          <Space size={6}>
            <Button
              type="primary"
              size="small"
              icon={<img alt="icon" src={EyeFilled} />}
              onClick={handlePreview}
            />
            <Button
              type="primary"
              size="small"
              icon={<img alt="icon" src={DownloadFileOutlined} />}
              onClick={handleDownload}
            />
            {props.print ? (
              <Button
                type="primary"
                size="small"
                icon={<PrinterOutlined />}
                className={styles.print}
                onClick={_.debounce(() => {
                  window.open(
                    `https://drive.google.com/viewerng/viewer?url=${
                      downloadUrl ?? documentTemporaryUrl
                    }`,
                  );
                }, 500)}
              />
            ) : null}
          </Space>
        )}
      </Space>
    </Space>
  );
};

FileRow.defaultProps = {
  isRecent: false,
  isReadable: true,
};

export default FileRow;
